import * as React from 'react';
import { TextButton as TPATextButton } from 'wix-ui-tpa/TextButton';
import { TextButtonProps } from '../../../../types/AdaptedComponents';
import { UILibrary } from '../../../../types/UILibrary';

export const TextButton: React.FC<TextButtonProps> = (props) => {
  const onPageOpen = () => window.open(props.href);

  return (
    <TPATextButton
      data-ui-lib={'tpa' as UILibrary}
      disabled={props.disabled}
      data-hook={props.dataHook}
      aria-label={props.ariaLabel}
      onClick={props.onClick || onPageOpen}
    >
      {props.children}
    </TPATextButton>
  );
};
TextButton.displayName = 'TextButton';
